import React, { useEffect, useState } from 'react'
import { useParams, useSearchParams } from 'react-router'
import '@whereby.com/browser-sdk/embed'
import { Box, Stack, Heading, Text, Alert, Loading, Container } from '@/components/lib'
import api from '../api'
import utils from '@/utils/utils'

export default function Meeting () {
  const [meeting, setMeeting] = useState(null)
  const [error, setError] = useState(null)
  const [loading, setLoading] = useState(false)

  const { meetingId } = useParams()
  const [searchParams] = useSearchParams()
  const password = searchParams.get('password')

  useEffect(() => {
    if (!meetingId || !password) return setError('No meeting could be found.')
    setError(null)
    setLoading(true)
    api.trials.getPublicMeeting(meetingId, password, data => {
      setMeeting(data)
      setLoading(false)
    }, err => {
      setError('There was an error fetching the meeting: ' + err.message)
      setLoading(false)
    })
  }, [meetingId, password])

  return (
    <Stack gap={10} my={10} maxW='500px' mx='auto'>

      {loading && <Loading />}
      {error && <Alert status='error'>{error}</Alert>}
      {meeting && (
        <Container>
          <Stack gap={5} p={3} bg='bg.surface' rounded='md'>
            <Box>
              <Heading>{meeting.name}</Heading>
              <Text fontSize='sm' color='fg.muted'>Scheduled at {utils.formatDateTime(meeting.startAt)}</Text>
            </Box>
            <whereby-embed room={meeting.roomUrl} displayName='Participant' logo='off' lang='en' localization='off' background='off' style={{ width: '100%', height: '700px' }} />
          </Stack>
        </Container>
      )}

    </Stack>
  )
};
